import List from "./list/AdvanceList";
import Individual from "./individual/Advance";

export default { List, Individual };
